import React, { Component } from "react";
import { connect } from "react-redux";
import * as Picture from "../../utils/general/index";
import "./StaffForm.css";
import { bindActionCreators } from "redux";
import * as StaffActions from "../../Actions/StaffAdmission";
import * as sharedActions from "../../Actions/sharedActions";
import StaffDocumentsPrint from "./StaffDocumentsPrint";
import StaffCertificatePrint from "./StaffCertificatePrint";
import StaffQualificationPrint from "./StaffQualificationPrint";
import StaffSkillsPrint from "./StaffSkillsPrint";
import StaffExperiencePrint from "./StaffExperiencePrint";
import StaffSiblingsPrint from "./StaffSiblingsPrint";
import Moment from "moment";
import StaffMedicalCondition from "./PrintStaffMedical";
import LoaderWrapper from "../../components/HOC/LoaderWrapper";

class PrintStaffAdmissionForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imagePreviewUrl:
        "http://ctt.trains.com/sitefiles/images/no-preview-available.png",
      getSingleAddData: [],
      gotData: false,
      images: "",
      imageData: "",
      isLoading: true,
    };
  }
  // PrintContent = (el) => {
  //   const { getSingleAddData } = this.state;

  //   // get registration number safely
  //   const regNo = getSingleAddData && getSingleAddData.Staffs.staffId;
  //   const restoreTitle = document.title; // save original title
  //   document.title = `Staff_Admission_Form_${regNo}`; // set new title for printing

  //   var restorepage = document.body.innerHTML;
  //   var Printcontent = document.getElementById(el).innerHTML;
  //   document.body.innerHTML = Printcontent;
  //   window.print();
  //   document.title = restoreTitle; // restore original title
  //   document.body.innerHTML = restorepage;
  // };

  PrintContent = (el) => {
    const { getSingleAddData } = this.state;

    // Safely get the registration number
    const regNo = getSingleAddData && getSingleAddData.Staffs.staffId;

    // Backup the current document title
    const restoreTitle = document.title;

    // Set dynamic title for printing
    document.title = regNo
      ? `Staff_Admission_Form_${regNo.toString().padStart(4, "0")}` // optional zero-padding
      : "Staff_Admission_Form";

    // Backup current page content
    // const restorePage = document.body.innerHTML;

    // Get the content to print
    // const printContent = document.getElementById(el).innerHTML;
    // document.body.innerHTML = printContent;

    // Add a class to body before printing
    document.body.classList.add("printing");

    // Trigger print
    window.print();
    document.body.classList.remove("printing");
    // Restore original page content and title
    // document.body.innerHTML = restorePage;
    document.title = restoreTitle;
  };
  componentDidMount() {
    const { match } = this.props;

    this.props.shareAction
      .gAllData(
        `/api/staff/${match.params.id}`,
        this.props.StaffActions.getIndividualStaffData,
      )
      .then((success) => {
        this.setState({
          isLoading: false,
          imagePreviewUrl: Picture.makeStaffImageURL(
            this.state.getSingleAddData &&
              this.state.getSingleAddData.StaffImageUpload.fileName,
          ),
        });
        console.log(success);
      })
      .catch((error) => {
        this.setState({
          isLoading: true,
        });
      });
  }
  static getDerivedStateFromProps(nextProps, prevState) {
    if (prevState.getSingleAddData !== nextProps.getData) {
      return {
        getSingleAddData: nextProps.getData,
      };
    }
    return null;
  }
  render() {
    console.log("Image Path", this.state.imagePreviewUrl);
    console.log("DATA", this.state.getSingleAddData);
    return (
      <div>
        <LoaderWrapper isLoading={this.state.isLoading}>
          <div id="div1">
            <section className="mb-4">
              <div className="">
                <img
                  src={require("../../Assets/images/header.png")}
                  style={{
                    width: "100%",
                    height: "150",
                  }}
                  alt="staff-admission-form-header"
                />
              </div>
              <br />
              <div className="row mZero print">
                <div className="col-md-12">
                  <div className="md-form mb-0">
                    <h2 className="FormHeadingStyle">
                      Staff Registration Form
                    </h2>
                  </div>
                </div>
              </div>
              <div className="row mZero print">
                <div className="col-md-12 text-right">
                  <div className="md-form mb-0">
                    <label className="mr-2">Date:</label>
                    <label className="font-weight-bold">
                      {this.state.getSingleAddData &&
                        this.state.getSingleAddData.Staffs.date}
                    </label>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row mZero" style={{ float: "right" }}>
                  <div className="col">
                    <div className="md-form mb-0">
                      <img
                        src={this.state.imagePreviewUrl}
                        alt="..."
                        height={220}
                        width={200}
                        className="rounded float-left shadow p-3 bg-light"
                        //   style={{ border: "solid" }}
                      ></img>
                    </div>
                  </div>
                </div>
                <div className="row rowStaffCheck" style={{ marginTop: 10 }}>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Registration No:{" "}
                    </label>
                    &nbsp;&nbsp; 0000
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.staffId}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Name In Arabic:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.fullNameArabic}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>First Name:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.StaffFirstName}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Last Name: </label>
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.lastName}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Father Name:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.fatherName}{" "}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Gender:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.gender}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Age:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.age}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Position:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.DepartmentName.departmentName}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Portal Refference:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.PostName.postName}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Designation:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.designation}{" "}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Subject Name:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.SubjectName.subjectName}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Grade:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.className}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Section:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.section}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Religion:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.religion}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Nationality:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                    this.state.getSingleAddData.Staffs.nationality !== null
                      ? Picture.getCountryName(
                          this.state.getSingleAddData &&
                            this.state.getSingleAddData.Staffs.nationality,
                        )
                      : ""}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Date of birth:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.dob,
                      ).toDateString()}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Place of birth:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.pob}{" "}
                  </div>
                </div>

                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Mobile Number:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.mobileNumber}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Phone No:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.phoneNo}{" "}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Email:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.email}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Passport Number:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.staffPassportNo}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Passport Issue Date:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.staffPassportDOI,
                      ).toLocaleDateString()}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Passport Expiry Date:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.staffPassportDOE,
                      ).toLocaleDateString()}
                  </div>
                </div>

                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      ID Card Number:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.staffIdcardNo}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      ID Card Issue Date:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.staffIdcardDOI,
                      ).toLocaleDateString()}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      ID Card Expiry Date:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.staffIdcardDOE,
                      ).toLocaleDateString()}{" "}
                  </div>
                </div>

                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Campus Name:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.CampusStaff.campusName}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Date Of Joining:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {/* {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.dateOfJoining
                      )
                     .toLocaleDateString()}{" "} */}
                    {this.state.getSingleAddData &&
                      new Date(
                        this.state.getSingleAddData.Staffs.dateOfJoining,
                      ).toDateString()}
                  </div>
                </div>

                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Username:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.userName}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Password:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.password}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Maritial Status:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.maritailStatus}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Account Status:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.status}{" "}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Basic Salary:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.basicSalary}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      Appraisal Status:
                    </label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.appraisalStatus}
                  </div>
                </div>
                <div className="row rowStaffCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Account Type:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.accountType}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Account Id:</label>
                    &nbsp;&nbsp;{" "}
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.accountId}
                  </div>
                </div>
              </div>
              <br />
              <div className="row print">
                <div className="col-md-12">
                  <div className="md-form mb-0">
                    <h2 className="FormHeadingStyle">Staff Address</h2>
                  </div>
                </div>
              </div>
              <div className="container">
                <div className="row rowCheck" style={{ marginTop: 10 }}>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>
                      State/Province:{" "}
                    </label>{" "}
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.address}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Area:</label>
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.streetNo}
                  </div>
                </div>
                <div className="row rowCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>House No: </label>
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.houseNo}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Way No:</label>
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.wayNo}
                  </div>
                </div>

                <div className="row rowCheck">
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>City:</label>
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.city}{" "}
                  </div>
                  <div className="col colStaffCheck">
                    <label style={{ fontWeight: "bold" }}>Country:</label>
                    &nbsp;&nbsp;
                    {this.state.getSingleAddData &&
                      this.state.getSingleAddData.Staffs.country}{" "}
                  </div>
                </div>
              </div>
              <br />
              <div className="hojaa">
                <StaffDocumentsPrint
                  Document={
                    this.state.getSingleAddData &&
                    this.state.getSingleAddData.StaffDocument
                  }
                />
              </div>
              <div className="row print">
                <div className="col-md-12">
                  <div className="md-form mb-0">
                    <h2 className="FormHeadingStyle">Staff Certificate</h2>
                  </div>
                </div>
              </div>
              {this.state.getSingleAddData &&
                this.state.getSingleAddData.Certificate.map((item, index) => (
                  <StaffCertificatePrint Document={item} />
                ))}
              <div className="row print">
                <div className="col-md-12">
                  <div className="md-form mb-0">
                    <h2 className="FormHeadingStyle">Staff Qualifications</h2>
                  </div>
                </div>
              </div>
              {this.state.getSingleAddData &&
                this.state.getSingleAddData.Qualifications.map(
                  (item, index) => <StaffQualificationPrint Document={item} />,
                )}

              <StaffMedicalCondition
                medicalCondition={
                  this.state.getSingleAddData &&
                  this.state.getSingleAddData.MedicalConditionStaffs
                }
              />

              <div className="row print">
                <div className="col-md-12">
                  <div className="md-form mb-0">
                    <h2 className="FormHeadingStyle">Staff Skills</h2>
                  </div>
                </div>
              </div>
              {this.state.getSingleAddData &&
                this.state.getSingleAddData.Skills.map((item, index) => (
                  <StaffSkillsPrint Document={item} />
                ))}
              <div className="row print">
                <div className="col-md-12">
                  <div className="md-form mb-0">
                    <h2 className="FormHeadingStyle">Staff Experiences</h2>
                  </div>
                </div>
              </div>
              {this.state.getSingleAddData &&
                this.state.getSingleAddData.Experiences.map((item, index) => (
                  <StaffExperiencePrint Document={item} />
                ))}
              {/* <div className="row print">
							<div className="col-md-12">
								<div className="md-form mb-0">
									<h2
										style={{
											backgroundColor: '#0A4F5E',
											textAlign: 'center',
											color: 'white'
										}}
									>
										Staff Siblings
									</h2>
								</div>
							</div>
						</div>
						{this.state.getSingleAddData &&
							this.state.getSingleAddData.Siblings.map((item, index) => (
								<StaffSiblingsPrint Document={item} />
							))} */}
            </section>
            {/* <div id="footer">
						<div className="row">
							<div className="col-md-12">
								<div className="text-center text-md-right">
									<label htmlFor="name" className="">
										Powered By School Smart®
									</label>
								</div>
							</div>
						</div>
					</div> */}
            <div className="row" style={{ marginTop: 150 }}>
              <div className="col-md-4 text-center">
                <input
                  type="text"
                  disabled
                  style={{ border: 0, borderBottom: "1px solid #000" }}
                />
                <br />
                <label className="font-weight-bold">
                  Principal's Signature
                </label>
              </div>
              <div className="col-md-4 text-center">
                <input
                  type="text"
                  disabled
                  style={{ border: 0, borderBottom: "1px solid #000" }}
                />
                <br />
                <label className="font-weight-bold">School Stamp</label>
              </div>
              <div className="col-md-4 text-center">
                <input
                  type="text"
                  disabled
                  style={{ border: 0, borderBottom: "1px solid #000" }}
                />
                <br />
                <label className="font-weight-bold">
                  Candidate's Signature
                </label>
              </div>
            </div>
            <div className="page-footer">
              <div className="text-left">
                Printed By: {this.props.users.role}
              </div>
              <div
                className="text-right"
                style={{ marginTop: -25, marginRight: 20 }}
              >
                Powered by School Smart®
              </div>
            </div>
            <div>
              <p style={{ color: "grey", textAlign: "center" }}>
                1305 building number 464/1, complex number 313. Madinat al Irfan
                Airport Heights - Bosher - Oman.
              </p>
            </div>
          </div>
          <div className="text-center text-md-right cursor-pointer">
            <label
              htmlFor="name"
              className="mb-4 cursor-pointer"
              onClick={() => {
                if (!this.state.isLoading) this.PrintContent("div1");
              }}
            >
              <i
                className="fas fa-print fa-2x animated fadeIn cursor-pointer"
                style={{ marginRight: 4 }}
              />
              Print
            </label>
          </div>
        </LoaderWrapper>
      </div>
    );
  }
}

function mapDispatchToProps(dispatch) {
  return {
    StaffActions: bindActionCreators(StaffActions, dispatch),
    shareAction: bindActionCreators(sharedActions, dispatch),
  };
}
function mapStateToProps(state) {
  return {
    getData: state.setStaffFormReducer.getSingleFormData,
    users: state.setUserReducer.users,
  };
}
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(PrintStaffAdmissionForm);
